module.exports = __webpack_public_path__ + "img/sybanner.b3308303.png";